module.exports = __webpack_public_path__ + "static/media/setaDisable.38e885aa.svg";